import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import callApi from '../../../../../../common/call-api';
import Button from '../../../../../../common/components/Button';
import ValidatedInput from '../../../../../../common/components/ValidatedInput';
import { getCurrentUser } from '../../../../../../redux-modules/current-user';
import { withLoading } from '../../../../../../redux-modules/loading-overlay';
import OrganizationActions from '../../../../../../redux-modules/organizations';
import CustomerActions from '../../../../../../redux-modules/customers';
import CurrentUserActions from '../../../../../../redux-modules/current-user';
import ErrorList from '../../../../components/ErrorList';
import { AssociationContainer } from './styles';

class AssociationForm extends React.Component {
  static propTypes = {
    actions: PropTypes.shape({
      organiztionCheck: PropTypes.object,
    }),
    currentUser: PropTypes.shape({
      id: PropTypes.string,
    }),
  };
  static promises = {
    includePromises: [
      {
        type: 'ENTITY/ENTITY_GET',
        meta: { namespace: 'organizations' },
      },
    ],
  };
  static inputProps = {
    organizationId: {
      label: 'Organization Member ID',
      validation: [
        {
          pattern: /^\d*$/,
          restrictInput: true,
          events: ['onChange'],
        },
      ],
    },
    primaryContactLastName: { label: "Primary Contact's Last Name" },
    postalCode: {
      label: 'Zip Code',
      validation: [
        {
          pattern: /^\d{0,5}$/,
          restrictInput: true,
          events: ['onChange'],
        },
        {
          checkValid: value => value.trim().length === 5,
          message: 'Please enter a valid zip code',
          events: ['onBlur'],
        },
      ],
    },
  };
  state = {
    errors: { request: {} },
    form: {
      organizationId: '',
      primaryContactLastName: '',
      postalCode: '',
    },
  };

  handleOnChange = key => (value, validation) => {
    const { isValid = true, message = '', restrictInput } = validation;
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [key]: restrictInput && !isValid ? prevState.form[key] : value,
      },
      errors: {
        ...prevState.errors,
        [key]: isValid || restrictInput ? '' : message,
        request: {},
      },
    }));
  };

  handleOnBlur = key => (value, validation) => {
    const { isValid = true, message = '' } = validation;
    if (!isValid) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [key]: message,
        },
      }));
    }
  };

  displayRequestErrors = results => {
    const { payload: { json = {} } = {} } = results || {};
    return this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        request: results.json || json,
      },
    }));
  };

  checkPassesValidation = () => {
    const { errors: { request, ...restErrors } = {} } = this.state;
    const validationErrors = Object.keys(restErrors).filter(
      key => (restErrors[key] || '').trim().length
    );
    if (validationErrors.length) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          request: { message: 'Please fix the error(s) below and try again.' },
        },
      }));
      return false;
    }
    return true;
  };

  handleSubmit = evt => {
    evt.preventDefault();
    const {
      form: { organizationId, primaryContactLastName, postalCode } = {},
    } = this.state;
    const { actions, currentUser: { id: userId } = {}, closeDialog } = this.props;

    if (!this.checkPassesValidation()) {
      return;
    }

    // validate org info
    return actions.organization
      .get(organizationId, {
        params: {
          primaryContactLastName,
          postalCode,
        },
      })
      .catch(this.displayRequestErrors)
      .then(results => {
        const { payload: { json, resp = {} } = {} } = results || {};
        if (resp.ok) {
          // call associate
          callApi('/api/cuss/association', {
            method: 'PUT',
            body: JSON.stringify({
              individualKey: userId,
              organizationKey: json.key,
              type: 'Secondary',
            }),
          }).then(result => {
            if (!result.resp.ok) {
              return this.displayRequestErrors(result);
            }
            actions.customer.get(userId);
            actions.currentUser.setType('SecondaryContact');
            closeDialog();
          });
        } else {
          this.displayRequestErrors(results);
        }
      });
  };

  render() {
    const { errors = {}, form = {} } = this.state;
    const { title } = this.props;
    return (
      <AssociationContainer>
        {title ? (
          <h2 style={{ marginBottom: '20px', fontSize: '1.8rem' }}>{title}</h2>
        ) : null}
        <p>
          If your organization is a member of NFIB, please provide the following
          information to associate your user profile to the respective
          membership account.
        </p>
        {errors.request && <ErrorList {...errors} />}
        <form onSubmit={this.handleSubmit}>
          {Object.keys(form).map(key => {
            const { validation = [], ...customProps } =
              AssociationForm.inputProps[key] || {};
            return (
              <ValidatedInput
                key={key}
                type="text"
                required
                value={form[key]}
                error={errors[key]}
                onChange={this.handleOnChange(key)}
                onBlur={this.handleOnBlur(key)}
                {...customProps}
                validation={[
                  ...validation,
                  {
                    checkValid: value => value.trim().length > 0,
                    message: 'This field is required.',
                    events: ['onBlur'],
                  },
                ]}
              />
            );
          })}
          <Button
            type="submit"
            style={{ width: '100%', marginTop: '8px' }}
            raised
            primary
            label="Associate"
          />
        </form>
      </AssociationContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentUser: getCurrentUser(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      organization: bindActionCreators(OrganizationActions, dispatch),
      customer: bindActionCreators(CustomerActions, dispatch),
      currentUser: bindActionCreators(CurrentUserActions, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withLoading(AssociationForm)
);



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/AssociationForm/index.js